export const RouteNames = {
  ONEPORTAL_INDEX: 'home',
  RECIPE: 'recipe'
}
